
import dynamicIcon from '~/mixins/dynamic-icon';

export default {
    mixins: [dynamicIcon],
    name: 'FavoritesClearIcon',
    props: {
        height: {
            type: String,
            default: () => '26'
        },
        width: {
            type: String,
            default: () => '26'
        }
    },
    mounted() {
        this.$emit('is-custom', !!this.handledHtmlIconCode('favourite_icon'));
    }
};
